import type { TabsProps } from 'antd';
import styles from './index.module.scss';
import Profile from './components/profile';
import Feeds from './components/feeds';
import Shorts from './components/shorts';

const PersonalNav = () => {
  const items: TabsProps['items'] = [
    {
      key: 'Profile',
      label: 'Profile',
      children: <Profile />,
    },
    {
      key: 'Feeds',
      label: 'Feeds',
      children: <Feeds />,
    },
    {
      key: 'Shorts',
      label: 'Shorts',
      children: <Shorts />,
    },
  ];
  return (
    <div className={styles.personalNav}>
      <Tabs
        className={styles.tabs}
        items={items}
        indicator={{ size: () => 12, align: 'center' }}
      ></Tabs>
    </div>
  );
};

export default PersonalNav;
